module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-exec-1946474241e425432e8c3a1869e3c86f.jpg";